let pluginManager = new ContaoWebpack.PluginManager();

window.swPluginManager = pluginManager;

import SwScrollInverter from "./plugins/ScrollInverter/inverter.plugin";
import SwScrollTo from "./plugins/ScrollTo/scrollto.plugin";
import SwVisibleAfter from "./plugins/VisibleAfter/visibleafter.plugin";
import SwClassAfter from "./plugins/ClassAfter/classafter.plugin";
import SwConsentBar from "./plugins/ConsentBar/consent.plugin";
import SwTouchNavigation from "./plugins/TouchNavigation/touch.plugin";
import OversizeHeadline from "./plugins/OversizeHeadline/headline.plugin";
import SwInput from "./plugins/Input/input.plugin";
import "./button.js";

pluginManager.registrate("SwInput", SwInput, "input, textarea, select");

pluginManager.registrate(
  "SwScrollInverter",
  SwScrollInverter,
  "[data-sw-scroll-inverter]",
);
pluginManager.registrate("SwScrollTo", SwScrollTo, "[data-sw-scroll-to]");
pluginManager.registrate(
  "SwVisibleAfter",
  SwVisibleAfter,
  "[data-sw-visible-after]",
);
pluginManager.registrate("SwClassAfter", SwClassAfter, "[data-sw-class-after]");
pluginManager.registrate("SwConsentBar", SwConsentBar, "[data-sw-consent-bar]");
pluginManager.registrate(
  "SwTouchNavigation",
  SwTouchNavigation,
  ".mod_navigation, .mod_tz_custom_navigation",
);
pluginManager.registrate(
  "OversizeHeadline",
  OversizeHeadline,
  "[data-oversize-headline]",
);

pluginManager.init();

const anchorNavigation = document.querySelectorAll(
    "aside#right .mod_module-anchor-navigation",
  ),
  swAsideRightCheckbox = document.getElementById("sw-aside-right");

anchorNavigation.forEach((el) => {
  el.querySelectorAll("a, span").forEach((link) => {
    link.addEventListener("click", (e) => {
      swAsideRightCheckbox.checked = false;
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const hashMatch = window.location.hash.match(/^#tz-anchor-(.+)$/);
  if (hashMatch) {
    const anchorValue = hashMatch[1];
    const targetElement = document.querySelector(
      `[data-tz-anchor='tz-anchor-${anchorValue}']`,
    );
    if (targetElement) {
      window.scroll({
        left: 0,
        behavior: "smooth",
        top: targetElement.offsetTop - 50,
      });

      history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search,
      );
    }
  }
});
